import { LOCAL_API, LOCAL_LANDING_API } from "./EnvironmentConfig";

const BASE_URL_CONFIG = "https://baseurl.rawdalsaleheen.edu.kw/index.json";

const applyLocalDefaults = () => {
  if (!localStorage.getItem("local")) {
    localStorage.setItem("local", LOCAL_API);
  }
  if (!localStorage.getItem("landing-local")) {
    localStorage.setItem("landing-local", LOCAL_LANDING_API);
  }
};

/**
 * Loads remote API base URLs into localStorage.
 * Always returns a Promise so the app can wait before first API calls.
 */
export const setBaseUrl = () => {
  applyLocalDefaults();
  // development and offline, don't fetch the base url
  if(process.env.NODE_ENV === 'development' && !navigator.onLine) return new Promise((resolve) => resolve());
  return fetch(BASE_URL_CONFIG)
    .then((response) => response.json())
    .then((data) => {
      localStorage.setItem("local", LOCAL_API);
      localStorage.setItem("landing-local", LOCAL_LANDING_API);
      if (data?.com) localStorage.setItem("com", data.com);
      if (data?.edu) localStorage.setItem("edu", data.edu);
      if (data?.backup) localStorage.setItem("backup", data.backup);
      if (data?.landing) localStorage.setItem("landing", data.landing);
      return data;
    })
    .catch((error) => {
      console.log("error ------- ", error);
      // Keep existing localStorage values / local defaults on failure
      return null;
    });
};
